module.exports = lvflanders.startscherm.ng.ui;